import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { apiGetGrupos, apiGetGroupById, apiSaveGroup } from "../api/gruposApi";

export const useGroup = () => {
  const [groups, setGroups] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedGroup, setSelectedGroup] = useState(null);

  const [form, setForm] = useState({
    id: "",
    codigo: "",
    descripcion: "",
    idruta: "",
    general: 0,
    inicial: "",
    final: "",
    orden: "",
    sexo: "",
    visible: 0,
    bloqueado: 0,
    estado: 1,
    id_empresa: 0,
  });


  const loadGroups = async (idruta = '') => {
    try {
      const res = await apiGetGrupos(idruta);
      const rs = typeof res?.json === "function" ? await res.json() : res;
      const list = Array.isArray(rs?.data) ? rs.data : (Array.isArray(rs) ? rs : []);
      setGroups(list);
    } catch {
      toast.error("fn loadGroups: Error cargando grupos");
    }
  };


  const loadGroupById = async (id) => {
    try {
      const res = await apiGetGroupById(id);

      if (!res.success) {
        toast.error("Ruta no encontrada");
        return;
      }

      const g = res.data;

      setForm({
        id: g.id,
        codigo: g.codigo || "",
        descripcion: g.descripcion || "",
        idruta: g.idRutas || "",
        general: g.General || 0,
        inicial: g.Inicial || 0,
        final: g.Final || 0,
        orden: g.Orden || 0,
        sexo: g.sexo || "",
        visible: g.visible || 0,
        bloqueado: g.bloqueado || 0,
        estado: g.estado,
        id_empresa: g.id_empresa || 0,
      });
    } catch {
      toast.error("fn loadGroupById: Error consultando grupo");
    }
  };

  const handleSelectGrupos = (id) => {
    setSelectedGroup(id);
    loadGroupById(id);
  };

  // ---- New  ----
  const handleNew = () => {
    setSelectedGroup(null);
    setForm({
      id: "",
      codigo: "",
      descripcion: "",
      idruta: "",
      general: 0,
      inicial: "",
      final: "",
      orden: "",
      sexo: "",
      visible: 0,
      bloquedo: 0,
      bloqueado: 0,
      estado: 1,
      id_empresa: 0,
    });
  };

  // ---- Save  ----
  const saveGroups = async () => {
    if (!form.codigo) {
      toast.error("El codigo no puede ser vacio");
      return;
    }
    if (!form.descripcion) {
      toast.error("La descripcion no puede ser vacio");
      return;
    }

    try {
      const res = await apiSaveGroup(form);

      if (!res.success) {
        toast.error(res.message || "Error guardando ruta");
        return;
      }

      toast.success(res.message);
      loadGroups();
      handleNew();
    } catch {
      toast.error("fn saveGroups: Error guardando ruta");
    }
  };

  // Initial Load
  useEffect(() => {
    loadGroups();
  }, []);

  return {
    groups,
    search,
    setSearch,
    selectedGroup,
    form,
    setForm,
    handleNew,
    handleSelectGrupos,
    saveGroups,
    loadGroups,
  };
};
